import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslocoDirective } from '@jsverse/transloco';
import { FormInstanceStatusIconComponent } from '@modules/forms/components/form-grid/form-instance-status-icon/form-instance-status-icon.component';
import { FormGridService } from '@modules/forms/components/form-grid/services/form-grid.service';
import { ActionButtonsComponent } from '@modules/shared/action-buttons/action-buttons.component';
import { AuthenticationService } from '@modules/authentication/services/authentication.service';
import { Store } from '@ngrx/store';
import { selectClientCode } from '@shared/store/router/router.selectors';

@Component({
  selector: 'pxc-form-grid-group-header-cell',
  templateUrl: './form-grid-group-header-cell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex items-center justify-between gap-2',
  },
  imports: [DatePipe, TranslocoDirective, ActionButtonsComponent, FormInstanceStatusIconComponent],
})
export class FormGridGroupHeaderCellComponent {
  readonly entityKey = input.required<string>();
  readonly type = input.required<string>();

  private readonly formGridService = inject(FormGridService);
  private readonly authenticationService = inject(AuthenticationService);
  private readonly clientCode = toSignal(inject(Store).select(selectClientCode));

  readonly date = computed(() => this.formGridService.date(this.entityKey(), this.type()));
  readonly showTodayLabel = computed(() => this.formGridService.showTodayLabel(this.entityKey(), this.type()));
  readonly actions = computed(() => this.formGridService.actions(this.entityKey(), this.type()));
  readonly actionButtons = computed(() => this.formGridService.actionButtons(this.entityKey(), this.type()));
  readonly status = computed(() => this.formGridService.status(this.entityKey(), this.type()));

  readonly changesetExport = computed(() => {
    const formAnswer = this.formGridService.instance(this.entityKey(), this.type())?.formAnswer();
    if (!formAnswer) {
      return undefined;
    }
    return {
      exportedAt: new Date().toISOString(),
      clientCode: this.clientCode(),
      userId: this.authenticationService.user?.id,
      entityKey: this.entityKey(),
      type: this.type(),
      formAnswer,
    };
  });
}
